import {differenceInSeconds} from 'date-fns/differenceInSeconds'
import {parseISO} from 'date-fns/parseISO'

import {useAppSelector} from '../../../../../../../hooks/react-redux'
import useTimeSelector from '../../../../../../../hooks/useTimeSelector'
import {getBuild} from '../../../../../../../selectors'
import type {BuildId} from '../../../../../../../types'
import {useBuildOvertimeInfo} from '../../../../../../../utils/buildOvertime'
import {formatDuration} from '../../../../../../../utils/dateTimeUtils'

export const useDuration = (runId: BuildId) => {
  const buildState = useAppSelector(state => getBuild(state, runId)?.state)
  const startDate = useAppSelector(state => getBuild(state, runId)?.startDate)
  const queuedDate = useAppSelector(state => getBuild(state, runId)?.queuedDate)
  const leftSeconds = useAppSelector(state => getBuild(state, runId)?.['running-info']?.leftSeconds)
  const elapsedSeconds = useAppSelector(
    state => getBuild(state, runId)?.['running-info']?.elapsedSeconds,
  )
  const startOrNow = useTimeSelector(now => Number(startDate ?? now))

  const {isOvertime, seconds: overtime} = useBuildOvertimeInfo(runId)

  if (buildState === 'queued' && queuedDate != null) {
    return `${formatDuration(differenceInSeconds(startOrNow, parseISO(queuedDate)))} in queue`
  }
  if (overtime != null && isOvertime) {
    return `${formatDuration(overtime)} overtime`
  }
  if (leftSeconds == null || leftSeconds < 0) {
    return `${formatDuration(elapsedSeconds)} passed`
  }
  return `${formatDuration(leftSeconds || 0)} left`
}
